import {
  AMOUNT_VALIDATOR,
  REQUIRED_OBJECT_VALIDATOR,
  REQUIRED_TEXT_FIELD_VALIDATOR,
  TEXT_FIELD_VALIDATOR,
} from '@/helpers/formHelpers/validators';
import { OptionType } from '@/components/form/fields/Select/Select';
import { WIRE_TYPE_SINGULAR_LABEL } from '@/const/wire';
import { WireTypesType } from '../../const/const';
import { object } from 'yup';

const INBOUND_WIRE_OPTION = { value: 'inbound', label: WIRE_TYPE_SINGULAR_LABEL.inbound };
const OUTBOUND_WIRE_OPTION = { value: 'outbound', label: WIRE_TYPE_SINGULAR_LABEL.outbound };

export const WIRES_OPTIONS = [INBOUND_WIRE_OPTION, OUTBOUND_WIRE_OPTION];

export const getCreateWireInitialValues = (currencyOptions: OptionType[], selectedWireType: WireTypesType) => {
  const selectedWireOption = WIRES_OPTIONS.find((item) => item.value === selectedWireType);

  return {
    type: selectedWireOption,
    name: '',
    amount: '',
    currency: currencyOptions[0],
    expected_payment_date: '',
    notes: '',
  };
};

export const CREATE_WIRE_VALIDATION_SCHEMA = object().shape({
  type: REQUIRED_OBJECT_VALIDATOR,
  name: REQUIRED_TEXT_FIELD_VALIDATOR,
  amount: AMOUNT_VALIDATOR,
  currency: REQUIRED_OBJECT_VALIDATOR,
  notes: TEXT_FIELD_VALIDATOR,
});
